import { render, staticRenderFns } from "./VirtualSupplierAttendeeFAQ.vue?vue&type=template&id=6ce33766&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports